import { Flex } from 'components/flex';
import { ReactNode, SelectHTMLAttributes } from 'react';

import styled from 'styled-components';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  children: ReactNode;
}

const Select = styled('select')`
  outline: none;
  background: white;
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  position: relative;

  &::-ms-expand {
    display: none;
  }

  option {
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }

  ${({ theme: { mediaQueries, fontSizes } }) => {
    return `
      max-width: 75px;
      font-size: ${fontSizes[0]};
      color: transparent;
      padding: 8px 0 8px 10px;
      border: 0;

      ${mediaQueries.desktop} {
        max-width: 150px;
        font-size: ${fontSizes[1]};
        color: black;
        padding: 8px 30px 8px 45px;
        border: 1px solid ${(props: any) => (props['data-error'] ? props.theme.colors.alert_400 : props.theme.colors.gray_300)};
        border-radius: 4px;
      }
    `;
  }}
`;

const Arrow = styled('i')`
  border-top: 5px solid ${({ theme }) => theme.colors.primary_200};
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  right: 15px;
  pointer-events: none;
`;

const Wrapper = styled(Flex)`
  position: relative;
`;

const Flag = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 8px;
  z-index: 15;
  width: 30px;
  height: 21px;
  flex-shrink: 0;
`;

const SelectCountry = ({ children, ...props }: SelectProps) => (
  <Wrapper>
    <Arrow />

    <Flag src="https://www.countryflags.com/wp-content/uploads/brazil-flag-png-large.png" />

    <Select {...props}>{children}</Select>
  </Wrapper>
);

export default SelectCountry;
